/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const polkadot_relay_chain_about = () => `Polkadot stands out among other blockchain projects for its focus on enhancing the foundational infrastructure of dApps. It aims to enable interoperability between blockchain ecosystems, facilitating seamless communication without intermediaries. Functioning as a "network of networks," Polkadot utilizes parachains — specialized blockchains with unique functionalities and tokens — to enable interaction between diverse blockchain architectures. Powered by the nominated proof-of-stake (PoS) consensus algorithm and drawing inspiration from the Ouroboros protocol, Polkadot offers a robust framework for building interconnected and scalable decentralized systems.`
